/*
 * @Author: cc
 * @LastEditTime: 2022-04-06 17:49:43
 */
import "./styles/index.scss";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import App from "./routes/index";
import "antd/dist/antd.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Provider } from "react-redux";
import store from "./reducers/index";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import { PersistGate } from "redux-persist/lib/integration/react";
import { watch, ranDomNum, preventOpenMoreVideoFn } from "./common/utils";
import { persistor } from "./reducers/index";
library.add(fas);
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
    <PersistGate persistor={persistor}>
      <App />
      </PersistGate>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
window.onCCH5PlayerLoaded = () => {
  window.ccH5PlayerJsLoaded = true;
};
window.on_player_volumechange = (volume: any, vid: any) => {
  console.log("设置音量回调:  ", volume, vid);
};
/**CC视频开始播放
 * @param {video}视频信息
 * @param {vid} vid
 * @return {void}
 */
window.on_CCH5player_play = (video: any, vid: any) => {
  console.log("----play----");
  clearInterval(window["playing"] as any);
  watch();
  // 每30秒调用一次接口
  (window["playing"] as any) = setInterval(() => {
    watch();
    preventOpenMoreVideoFn("1");
  }, 30000);
};
/**CC视频暂停
 * @param {any}
 * @param {vid} vid
 * @return {void}
 */
window.on_CCH5player_pause = (video: any, vid: string) => {
  console.log("----暂停----");
  watch();
  ranDomNum.pause();
  // 清空30秒上传数据接口
  clearInterval(window["playing"]);
  preventOpenMoreVideoFn("0");
};
/**CC播放结束
 * @param {any}
 * @param {vid} vid
 * @return {void}
 */
window.on_CCH5player_ended = (video: any, vid: string) => {
  console.log("----结束----",video,vid);
  window.video_end()
  watch();
  // 清空随机数计时器
  ranDomNum.pause();
  preventOpenMoreVideoFn("0");
  // 清空30秒上传数据接口
  clearInterval(window["playing"]);
};
reportWebVitals();
